import { gql } from '../../../apollo/__generated__';

export const USER_TARGETS = gql(`
  query UserTargets($eventId: ID!) {
    userTargets(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      targetCount(eventId: $eventId)
    }
  }
`);
